<template>
  <div :class="{ 'dark-mode': isDark, 'ma-3': !inDialog }">
    <v-card :dark="isDark" :class="['border-radius-10', noBox]" v-if="(mode == 'insert' || mode == 'update')">
      <v-card-title class="main-gradient" v-if="!isDark">
        <span class="font-weight-black title title-form font-paralucent h-full " v-if="mode == 'insert'">{{i18n('Criar Usuário')}}</span>
        <v-spacer></v-spacer>
        <v-icon class="cursor-type" right @click="$emit('cancel')" v-if="inDialog">close</v-icon>
      </v-card-title>
      <v-card-text :class="[noMargin, 'pb-0']">
        <v-container :class="['grid-list-md', 'px-3', 'py-0', noMargin]">
          <v-flex class="xs12">
            <v-layout class="row wrap">
              <v-flex class="xs12 lg6 pr-lg-2">
                <v-text-field box
                  v-model="record.name"
                  :dark="isDark"
                  :label="i18n('Nome')"
                />
              </v-flex>
              <v-flex class="xs12 lg6 pl-lg-2">
                <v-text-field box
                  v-model="record.username"
                  :dark="isDark"
                  :label="i18n('Email do Usuário')"
                  :errorMessages="this.errors.username"
                />
              </v-flex>
              <v-flex class="xs12" v-if="hasURL">
                <v-layout align-center>
                <v-flex class="xs11">
                  <v-text-field box
                    readonly
                    v-if="hasURL"
                    v-model="record.set_password_url"
                    :dark="isDark"
                    :label="i18n('URL')" />
                  </v-flex>
                  <v-flex xs1 class="text-xs-right">
                    <v-btn icon @click="copyToClipboard(record.set_password_url)">
                      <v-icon>content_copy</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                </v-flex>
              <v-flex class="xs12 subheading p-0 pl-3" v-if="mode === 'update'">
                <span>Status: <span>{{humanStatus(record.status)}}</span></span>
                <v-btn flat class="flex-1 btn-bg-color font-weight-black ml-3" @click="openActivationDialog" v-if="record.status == 'not_active'">{{i18n('Ativar usuário')}}</v-btn>
                <v-btn flat class="flex-1 secondary-btn-bg-color font-weight-black ml-3" @click="openDeactivationDialog" v-if="record.status == 'active'">{{i18n('Desativar usuário')}}</v-btn>
                <v-btn v-if="display2FAResetButton" class="flex-1 secondary-btn-bg-color font-weight-black" @click="open2FADialog">{{i18n('Redefinir 2FA')}}</v-btn>
              </v-flex>
              <v-flex class="xs12 no-bottom-padding">
                <v-list subheader class="first-permission-group" :dark="isDark">
                  <v-subheader>{{i18n('Permissões')}}</v-subheader>
                  <v-list-tile v-for="p in transactionPermissions" :key="p.value">
                    <v-list-tile-action>
                      <v-switch v-model="record.permissions" :disabled="p.disabled" :value="p.value" @change="validateTypeExchange(p.value)"></v-switch>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{p.text}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex class="xs6 mt-0 pt-0">
                <v-list subheader>
                  <v-list-tile v-for="p in userPermissions" :key="p.value">
                    <v-list-tile-action>
                      <v-switch v-model="record.permissions" :value="p.value"></v-switch>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{p.text}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-switch
                      v-model="enableIpForm"
                      :label="i18n('Habilitar permissão por endereço IP')"
                      :dark="isDark"
                    ></v-switch>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex class="xs6 mt-0 pt-0">
                <v-list subheader>
                  <v-list-tile v-for="p in tokenPermissions" :key="p.value">
                    <v-list-tile-action>
                      <v-switch v-model="record.permissions" :value="p.value"></v-switch>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{p.text}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="enableIpForm" class="xs12 lg12">
            <v-subheader >{{ i18n('Endereços IPs Permitidos') }}</v-subheader>
            <v-layout wrap class="px-2">
              <v-flex xs12>
                <v-chip
                  class="fixed-chip mr-2"
                  v-for="(ip, index) in record.ip_list"
                  :key="index"
                  text-color="white"
                  close
                  @input="removeIp(index)"
                >
                  {{ ip }}
                </v-chip>
              </v-flex>
              <v-flex xs12 sm7 md7 lg7 xl5>
                <v-flex>
                  <v-text-field
                    box
                    :dark="isDark"
                    v-model="newIp"
                    :label="i18n('Adicionar novo endereço IP')"
                    @input="formatIp"
                    @keyup.enter="addIp"
                    dense
                    maxlength="15"
                    placeholder="0.0.0.0"
                  />
                </v-flex>
                <v-flex mb-4 style="margin-top: -20px;">
                  <v-messages
                    box
                    v-if="errors.ip_list && errors.ip_list.length"
                    :value="errors.ip_list"
                    color="error"
                    style="font-size: 16px;"
                  />
                </v-flex>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-btn
                  @click="addIp"
                  class="flex-1 btn-bg-color font-weight-black"
                  block
                >
                  {{ i18n('Adicionar') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="!isDark">
        <v-layout class="row wrap">
          <v-flex class="xs12 justify-flex-end mb-3"  v-if="mode === 'insert'">
            <v-btn flat class="flex-1 secondary-btn-bg-color font-weight-black ml-3" @click="cancel">{{i18n('Cancelar')}}</v-btn>
            <v-btn class="flex-2 btn-bg-color text-color-white strong font-weight-black mr-3" @click="createUser">{{i18n('Registrar')}}</v-btn>
          </v-flex>
          <v-flex class="xs12 justify-flex-end mb-3" v-if="mode === 'update'">
            <v-btn flat class="flex-1 secondary-btn-bg-color font-weight-black ml-3" @click="cancel">{{i18n('Cancelar')}}</v-btn>
            <v-btn class="flex-2 btn-bg-color text-color-white strong font-weight-black mr-3" @click="updateUser">{{i18n('Atualizar')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
    <div class="buttons-container mt-3" v-if="isDark">
      <v-layout class="row wrap">
        <v-flex class="xs12 justify-flex-end mb-3"  v-if="mode === 'insert'">
          <v-btn flat class="flex-1 secondary-btn-bg-color font-weight-black ml-3" @click="cancel">{{i18n('Cancelar')}}</v-btn>
          <v-btn class="flex-2 btn-bg-color text-color-white strong font-weight-black mr-3" @click="createUser">{{i18n('Criar Usuário')}}</v-btn>
        </v-flex>
        <v-flex class="xs12 justify-flex-end mb-3" v-if="mode === 'update'">
          <v-btn flat class="flex-1 secondary-btn-bg-color font-weight-black" @click="cancel">{{i18n('Cancelar')}}</v-btn>
          <v-btn class="flex-2 secondary-btn-bg-color font-weight-black btn-bg-color text-color-white" @click="updateUser">{{i18n('Atualizar')}}</v-btn>
        </v-flex>
      </v-layout>
    </div>
    <ConfirmModal :dialog="enableUserConfirmation" :title="i18n('Habilitar usuário')" :user="user" @onCancel="enableUserConfirmation = false" @onConfirm="enableUser">
      {{i18n('Você tem certeza')}}?
    </ConfirmModal>
    <ConfirmModal :dialog="disableUserConfirmation" :title="i18n('Desabilitar usuário')" :user="user" @onCancel="disableUserConfirmation = false" @onConfirm="disableUser">
      {{i18n('Você tem certeza')}}?
    </ConfirmModal>
    <ConfirmModal :dialog="enable2FADialog" :title="i18n('Remover código de 2FA')" :user="user" @onCancel="enable2FADialog = false" @onConfirm="reset2fa">
      {{i18n('Você tem certeza')}}?
    </ConfirmModal>
  </div>
</template>

<script>
  import utils from "./shared/Utils"
  import ConfirmModal from './ConfirmModal'
  import translateOldPermissions from "./shared/translateOldPermissions"

  const standard_permissions = ['transactions-create-receive', 'transactions-create-pay', 'transactions-create-deposit', 'transactions-create-withdrawal_internal']

  export default {
    name: 'UsersForm',
    props: {
      mode: {
        type: String
      },
      inDialog: {
        type: Boolean,
        default: false
      },
      isDark: {
        type: Boolean,
        default: false
      },
      company_id: {
        type: String
      },
      user: {
        type: Object
      }
    },
    components: { ConfirmModal },
    created() {
      this.fetchExchangeTriggerRule();
    },
    data() {
      return {
        record: {
          name: '',
          username: '',
          permissions: standard_permissions,
          ip_list: []
        },
        errors: {},
        enable2FADialog: false,
        display2FAButtonIfAble: true,
        enableUserConfirmation: false,
        disableUserConfirmation: false,
        tokenPermissions: [
          { text:  this.i18n('Criar Usuário'), value: 'users-create' },
          { text:  this.i18n('Habilitar Usuário'), value: 'users-enable' },
          { text:  this.i18n('Cancelar Token'), value: 'tokens-cancel' }
        ],
        userPermissions: [
          { text:  this.i18n('Listar Usuários'), value: 'users-list' },
          { text:  this.i18n('Desabilitar Usuário'), value: 'users-disable' },
          { text:  this.i18n('Criar Token'), value: 'tokens-create' }
        ],
        transactionPermissions: [
          { text:  this.i18n('Cobrar do cliente'), value: 'transactions-create-receive' },
          { text:  this.i18n('Pagar cliente'), value: 'transactions-create-pay' },
          { text:  this.i18n('Depósito em conta interna'), value: 'transactions-create-deposit' },
          { text:  this.i18n('Retirada de conta interna'), value: 'transactions-create-withdrawal_internal' },
          { text:  this.i18n('Conversão entre contas internas'), value: 'transactions-create-exchange_internal' }
        ],
        newIp: '',
        enableIpForm: false,
        exchangeTriggerRule: undefined,        
      }
    },
    methods: {
      validateTypeExchange(field) {
        switch(field) {
          case "facilita_exchange_only":
            if (this.record.permissions.includes('customer_exchange_only')) {
              this.record.permissions.splice(this.record.permissions.indexOf('customer_exchange_only'), 1);
            }
            break
          case "customer_exchange_only":
            if (this.record.permissions.includes('facilita_exchange_only')) {
              this.record.permissions.splice(this.record.permissions.indexOf('facilita_exchange_only'), 1);
            }
            break
        }
      },
      i18n(str) {
        return this.$root.l(str)
      },
      humanStatus(str) {
        if (str == 'active') {
          return this.i18n('Ativo')
        }
        if (str == 'not_active') {
          return this.i18n('Não Ativo')
        }
        if (str == null) {
          return this.i18n('Não Ativo')
        }
        return str
      },
      errorMessagesFor(field) {
        if (this.errors[field]) {
          return this.errors[field]
        } else {
          return []
        }
      },
      createUser() {
        if (!this.validateIpList()) return

        let user = {...this.record, name: this.record.name.trim(), username: this.record.username.trim()}
        const payload = { user }
        let successCallback = (response) => {
          if (response.body.data) {
            this.$emit('onUserCreate', response.body.data)
            this.resetForm()
          } else {
            console.log(response)
          }
        }
        let errorCallback = (response) => {
          if (response.body.errors) {
            let errors = utils.translateErrors(response.body.errors, this.$root.lang)
            this.$set(this, 'errors', errors)
          }
        }
        const token = this.$cookies.get('api_token')
        this.$http.post(this.users_url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      updateUser() {
        if (!this.validateIpList()) return

        const user = {...this.user, username: this.record.username, name: this.record.name, permissions: this.record.permissions,  ip_list: this.enableIpForm ? this.record.ip_list.filter(ip => ip) : []}
        const payload = { user }

        let successCallback = (response) => {
          if (response.body.data) {
            const current_username = this.$cookies.get('email')
            if (current_username === user.username) {
              const expire_at = new Date(new Date().getTime() + 60 * 12 * 60000) // 12 hours
              this.$cookies.set("user_permissions", JSON.stringify(user.permissions), expire_at)
              this.$cookies.set("name", user.name, expire_at)
            }
            this.$emit('onUserUpdate', response.body.data)
            this.resetForm()
          } else {
            console.log(response)
          }
        }

        let errorCallback = (response) => {
          if (response.body.errors) {
            let errors = utils.translateErrors(response.body.errors, this.$root.lang)
            this.$set(this, 'errors', errors)
          }
        }

        const token = this.$cookies.get('api_token')
        this.$http.put(`${this.users_url}${this.user.id}`, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      cancel() {
        this.$emit('cancel')
        this.resetForm()
      },
      resetForm() {
        let record = {
          name: '',
          username: '',
          permissions: standard_permissions,
          ip_list: [],
          set_password_url: ''
        }
        if (this.user && this.user.id) {
          record = { name: this.user.name, username: this.user.username, permissions: translateOldPermissions(this.user.permissions), status: this.user.status, set_password_url: this.user.set_password_url, ip_list: (this.user.ip_list || []).slice()}}

        this.$set(this, 'record', record)
        this.$set(this, 'errors', {})
      },
      openActivationDialog() {
        this.disableUserConfirmation = false
        this.enableUserConfirmation = true
      },
      openDeactivationDialog() {
        this.enableUserConfirmation = false
        this.disableUserConfirmation = true
      },
      open2FADialog() {
        this.enable2FADialog = true
      },
      enableUser() {
        this.enableUserConfirmation = false
        let successCallback = (response) => {
          if (response.body.data) {
            this.$root.$emit('userUpdated', response.body.data)
            this.record.set_password_url = response.body.data.set_password_url
            this.record.status = response.body.data.status
          } else {
            console.log(response)
          }
        }

        let errorCallback = (response) => {
          console.log(response)
        }

        const token = this.$cookies.get('api_token')
        const url = `${this.toggle_user_url}${this.user.id}/enable`
        this.$http.put(url, {}, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      disableUser() {
        this.disableUserConfirmation = false
        let successCallback = (response) => {
          if (response.body.data) {
            this.$root.$emit('userUpdated', response.body.data)
            this.record.set_password_url = null
            this.record.status = response.body.data.status
            this.cancel()
          } else {
            console.log(response)
          }
        }

        let errorCallback = (response) => {
          console.log(response)
        }

        const token = this.$cookies.get('api_token')
        const url = `${this.toggle_user_url}${this.user.id}/disable`
        this.$http.put(url, {}, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      reset2fa() {
        this.enable2FADialog = false
        let successCallback = (response) => {
          if (response.body.data) {
            this.display2FAButtonIfAble = false
          } else {
            console.log(response)
          }
        }

        let errorCallback = (response) => {
          console.log(response)
        }

        const token = this.$cookies.get('api_token')
        const url = `${this.toggle_user_url}${this.user.id}/clear2fa`
        this.$http.put(url, {}, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      isValidIPv4(ip) {
        const regex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;
        return regex.test(ip);
      },
      addIp() {
        const ip = this.newIp.trim();
        if (!ip || ip === '') {
          this.$set(this.errors, 'ip_list', [this.i18n('Formato de Endereço IP inválido')]);
          return;
        }

        this.$set(this.errors, 'ip_list', []);

        if (!this.isValidIPv4(ip)) {
          this.$set(this.errors, 'ip_list', [this.i18n('Formato de Endereço IP inválido')]);
          return;
        }

        if (this.record.ip_list.includes(ip)) {
          this.$set(this.errors, 'ip_list', [this.i18n('Endereço IP já adicionado')]);
          return;
        }

        this.record.ip_list.push(ip);
        this.newIp = '';
      },
      removeIp(index) {
        this.record.ip_list.splice(index, 1)
      },
      validateIpList() {
        this.$set(this.errors, 'ip_list', [])

        if (!this.enableIpForm) {
          return true
        }

        if (!this.record.ip_list || this.record.ip_list.length === 0) {
          this.$set(this.errors, 'ip_list', [this.i18n('É necessário pelo menos um endereço IP')])
          return false
        }

        return true
      },
      formatIp(value) {
        let clean = value.replace(/[^0-9.]/g, '');
        let segments = clean.split('.');
        let blocks = [];

        for (let i = 0; i < segments.length && blocks.length < 4; i++) {
          let segment = segments[i];

          if (segment.length > 0) {
            while (segment.length > 3 && blocks.length < 4) {
              const part = segment.slice(0, 3);
              blocks.push(parseInt(part, 10).toString());
              segment = segment.slice(3);
            }

            if (blocks.length < 4 && segment.length > 0) {
              blocks.push(parseInt(segment, 10).toString());
            }
          }
        }

        this.newIp = blocks.join('.');
      },
      copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(() => {
          this.$emit('copied', text)
        }).catch(err => {
          console.error('Failed to copy text: ', err)
        })
      },
    async fetchExchangeTriggerRule() {
      try {
        const token = this.$cookies.get('api_token')
        const partnerConfigUrl = this.$root.urls.customer__show_partner_company_config.replace('ID', this.$cookies.get('company_id'))
        let response = await this.$http.get(
          partnerConfigUrl,
          { headers: { Authorization: `Bearer ${token}` } }
        )

        this.exchangeTriggerRule = response.body.exchange_mode
      } catch (err) {
        console.log("Unable to fetch exchange trigger rule.")
      }
    },
    },
    watch: {
      enableIpForm(newValue) {
        if (!newValue) {
          this.$set(this.errors, 'ip_list', [])
        }
    },
    exchangeTriggerRule(value) {
      let exchangeControls

      const facilitaExchangeControl = { text: this.i18n('Definir opção "FX sob demanda" para todas as transações de câmbio'), value: 'facilita_exchange_only' }
      const customerExchangeControl = { text: this.i18n('Definir opção "FX automático" para todas as transações de câmbio'), value: 'customer_exchange_only' }

      switch (value) {
        case 'any':
          exchangeControls = [facilitaExchangeControl, customerExchangeControl]
          break;
        case 'fx_on_demand':
        case 'auto_fx':
          exchangeControls = []
          break;
        default:
          throw new Error(`Partner has a invalid exchange trigger rule. Value: ${JSON.stringify(value)}`)
      }

      this.transactionPermissions = [...this.transactionPermissions, ...exchangeControls]
    }
  },
    computed: {
      noBox() {
        return this.inDialog ? '' : 'elevation-0'
      },
      noMargin() {
        return this.inDialog ? '' : 'px-0'
      },
      hasURL() {
        return !!this.record.set_password_url
      },
      users_url() {
        return this.company_id
        ? this.$root.urls.admin__company_user__id.split('ID').join(this.company_id)
        : this.$root.urls.users
      },
      toggle_user_url() {
        return this.company_id
        ? this.$root.urls.admin__users
        : this.$root.urls.users
      },
      display2FAResetButton() {
        return this.user.has_2fa_enabled && this.display2FAButtonIfAble
      }
    },
    mounted() {
      this.resetForm()
      if (this.record.ip_list.length > 0) {
        this.enableIpForm = true
      }
    },
    metaInfo: {
      title: "Facilita Pay"
    }
  }
</script>

<style scoped>
.buttons-container {
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(188, 193, 209, 0.33);
  margin-left: 55px;
  margin-right: 55px;
  padding-top: 20px;
  margin-top: 20px;
}

.dark-mode .v-list,
.dark-mode .v-sheet.theme--dark {
  background: var(--background-color)!important;
}
.dark-mode .secondary-btn-bg-color{
  color: white !important;
}
.secondary-btn-bg-color{
  color: var(--background-color) !important;
}
.align-btn-toogle {
  padding-top: 20px!important;
  width: 100%!important;
  position: absolute!important;
  top: 40px;
  left: 0px;
  box-shadow: none!important;
}
.adjust-btn-width {
  width: 50%!important;
}
.account-type {
  display: flex;
  align-items: baseline;
  justify-content: left;
  flex-wrap: wrap;
}
.cancel-btn{
 background-color: rgba(0,0,0,.10)
}
.cancel-btn:hover{
 background-color: rgba(0,0,0,.07)
}
.position-relative{
  position: relative;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.justify-flex-end {
  display: flex;
  justify-items: flex-end;
}
.cursor-type{
  cursor: pointer;
}
.title-form{
  color: #44517B !important;
}
.font-paralucent {
  font-family: paralucent !important;
}
.btn-bg-color {
  background-color: var(--secondary-button-background-color) !important;
}
.text-color-white{
  color: white !important;
}
.hidden{
  display: none;
}
.dark-mode  .title-form{
  color: white !important;
}
.v-dialog {
  height: 100% !important;
}
.font-color{
  color: #44517B;
}
.v-dialog .v-dialog--active .v-dialog--persistent{
  height: 100%;
}
.no-bottom-padding .v-list {
  padding-bottom: 0px!important;
}
.first-permission-group {
  margin-top: -4px;
}
.v-chip.fixed-chip {
  align-items: center;
  font-size: 16px;
}
</style>




// WEBPACK FOOTER //
// src/UsersForm.vue